import { createFileRoute } from "@tanstack/react-router";
import { MembersRolesSettingsPage } from "@/features/settings/components/organization/members-roles-settings-page";

export const Route = createFileRoute("/settings/members-roles")({
  component: MembersRolesSettingsPage,
});
